import { useAutocomplete } from 'admin';
import type { CarrierInfo } from 'api';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

type Props = Omit<MultiAutocompleteFieldProps<CarrierInfo>, 'options' | 'isOptionEqualToValue' | 'getOptionLabel'>;
export const MultiCarrierAutocompleteField = (props: Props) => {
  const { autocompleteProps } = useAutocomplete<CarrierInfo>({
    dataProviderName: 'post_deal',
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: '/tracker/v1/carriers/',
  });

  return (
    <MultiAutocompleteField<CarrierInfo>
      {...autocompleteProps}
      {...props}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
    />
  );
};
